export default "__VITE_ASSET__15e8a62c__"